// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"Pagination_paginationWrapper__2F8et","select":"Pagination_select__3Kpsq"};